import { cloneObj } from "../../../js/util";

function UserCard(props) {
  const userHandleChange = (idx, e) => {
    const dataType = e.target.dataset["type"];
    //숫자타입인데 문자가 들어오는 경우 false
    let isState = true;
    if (dataType === "int") {
      if (isNaN(e.target.value)) {
        isState = false;
      }
    }

    if (isState) {
      let copiedObj = cloneObj(props.users);
      copiedObj[idx][e.target.name] = e.target.value;
      props.setUsers(copiedObj);
    }
  };

  return (
    <>
      {props.users.length > 0 ? (
        props.users.map((user, i) => {
          return (
            <div className="col-12 pb-20" key={i}>
              <div className="card">
                <div className="card-header">{user.userid || ""}</div>
                <div className="card-body">
                  <div className="container p-0 m-0">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">이름</label>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            value={user.username || ""}
                            onChange={(e) => userHandleChange(i, e)}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">휴대전화</label>
                          <input
                            type="text"
                            name="hp"
                            className="form-control"
                            maxLength="11"
                            data-type="int"
                            value={user.hp || ""}
                            onChange={(e) => userHandleChange(i, e)}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">계정권한</label>
                          <select
                            className="custom-select"
                            name="usertype"
                            value={user.usertype || "1"}
                            onChange={(e) => userHandleChange(i, e)}
                          >
                            <option value="0">관리자</option>
                            <option value="1">조합직원</option>
                            <option value="2">임원</option>
                            <option value="3">일반회원</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">상태</label>
                          <select
                            className="custom-select"
                            name="luse"
                            id="inputArea"
                            value={user.usertype || "1"}
                            onChange={(e) => userHandleChange(i, e)}
                          >
                            <option value="1">사용</option>
                            <option value="3">중지</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">등록일자</label>
                          <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            value={user.wdate || ""}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">
                            최근로그인
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            value={user.loginday || ""}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label className="form-control-label">
                            비밀번호변경
                          </label>
                          <input
                            type="password"
                            name="new_passwd"
                            className="form-control"
                            maxLength="20"
                            onChange={(e) => userHandleChange(i, e)}
                          />
                        </div>
                      </div>

                      <div className="col-12 text-center">
                        <span
                          className="btn btn-main btn-icon btn-round-full"
                          onClick={(e) => props.fnUserSaveClick(i, e)}
                        >
                          저장
                        </span>
                        &nbsp;&nbsp;
                        <span
                          className="btn btn-main-2 btn-icon btn-round-full"
                          onClick={(e) => props.fnUserDeleteClick(i, e)}
                        >
                          삭제
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="col-12 pb-20">가입된 사용자가 없습니다.</div>
      )}
    </>
  );
}

export default UserCard;
